import { render } from "./NotificationsSubPage.vue?vue&type=template&id=c987ef8e&scoped=true"
import script from "./NotificationsSubPage.vue?vue&type=script&lang=js"
export * from "./NotificationsSubPage.vue?vue&type=script&lang=js"

import "./NotificationsSubPage.vue?vue&type=style&index=0&id=c987ef8e&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c987ef8e"]])

export default __exports__